import React from 'react';
import { CLOUDFRONT_ASSET_URL } from '@osmosis/constants';
import Head from 'next/head';

type TwitterMetaDataProps = {
  title?: string;
  descr?: string;
  card?: string;
  image?: string;
  player?: string;
};

/**
 * Head component for Twitter metadata.
 */
const TwitterMetaData = (props: TwitterMetaDataProps): JSX.Element => {
  const {
    card = 'summary',
    player,
    title = 'Osmosis - A Better Way To Learn',
    descr = "Osmosis is an efficient, enjoyable, and social way to learn. Sign up for an account today! Don't study it, Osmose it.",
    image = `${CLOUDFRONT_ASSET_URL}3800be6d2ddada94d64b161e67f637d496dd732e.png`,
  } = props;

  return (
    <Head>
      <meta name="twitter:title" content={`Osmosis - ${title}`} />
      <meta name="twitter:description" content={descr} />
      <meta name="twitter:card" content={card} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:site" content="@OsmosisMed" />
      <meta name="twitter:creator" content="@OsmosisMed" />
      {player ? <meta name="twitter:player" content={player} /> : null}
    </Head>
  );
};

export default TwitterMetaData;
